// extracted by mini-css-extract-plugin
export default {"pagehome":"homecontent_pagehome__VZcXC","homecontent":"homecontent_homecontent__bb+Y7","teaserimage":"homecontent_teaserimage__nMpX5"};